// src/components/subscriptions/DiscountRequestModal.js
import React, { useState } from 'react';
import { licenseService } from '../../services/licenseService';
import './DiscountRequestModal.css';

const DiscountRequestModal = ({ onSubmit, onClose, invoiceContext = null }) => {
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!reason.trim()) {
            alert('Please provide a reason for the discount request');
            return;
        }

        try {
            setLoading(true);
            // Send a default percentage of 0, admin will set the actual percentage when approving
            await licenseService.requestDiscount(0, reason, null, invoiceContext);
            onSubmit();
        } catch (error) {
            console.error('Failed to submit discount request:', error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="discount-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Request Discount</h3>
                    <button className="close-btn" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <div className="info-box">
                            <i className="fas fa-info-circle"></i>
                            <p>
                                Request a discount on your subscription. Our admin team will review your request
                                and determine an appropriate discount percentage based on your circumstances.
                                Once approved, the discount is saved on your organization and will be used for future invoices.
                            </p>
                        </div>

                        <div className="form-group">
                            <label htmlFor="reason">
                                Reason for Discount Request
                                <span className="required">*</span>
                            </label>
                            <textarea
                                id="reason"
                                rows="7"
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                placeholder="Please explain why you are requesting a discount. Include details such as:&#10;- Your organization type and mission&#10;- Number of employees/users&#10;- Industry sector&#10;- Budget constraints or financial situation&#10;- Any special circumstances&#10;&#10;The more detail you provide, the better we can evaluate your request."
                                required
                            />
                            <small className="help-text">
                                Provide a detailed explanation to help us evaluate your request
                            </small>
                        </div>

                        <div className="warning-box">
                            <i className="fas fa-exclamation-triangle"></i>
                            <p>
                                Your discount request will be reviewed by our admin team.
                                If approved while your current invoice is still pending, it is also applied there.
                                If you cancel that pending invoice, create a new one and the approved organization discount will carry forward.
                                You will receive a notification once your request has been processed.
                            </p>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="cancel-btn"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="submit-btn"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-small"></span>
                                    Submitting...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-paper-plane"></i>
                                    Submit Request
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DiscountRequestModal;
